//
// sweet-alert-service.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/* global angular: false, sweetAlert: false */

((() => {
    const ALERT_OPTIONS = {
        confirmButtonClass: 'btn-default',
    };

    const CONFIRM_OPTIONS = {
        showCancelButton: true,
        cancelButtonClass: 'btn-link-primary',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'btn-default',
        confirmButtonText: 'OK',
    };

    angular.module('curalate').service('SweetAlert', ['$q', $q => ({
        /**
         * Displays an alert dialog.
         *
         * @param message a String containing the message text, or an Object containing various parameters
         */
        alert(message) {
            if (typeof message === 'string') {
                sweetAlert(_.extend(ALERT_OPTIONS, { title: message }));
            } else if (typeof message === 'object') {
                sweetAlert(_.extend(ALERT_OPTIONS, message));
            } else {
                throw new Error(`Message parameter must be a String or Object.  Message = ${message}`);
            }
        },

        /**
         * Displays a confirmation dialog and returns a promise that responds when the user clicks 'OK' or 'Cancel'.
         *
         */
        confirm(options) {
            const deferred = $q.defer();
            const mergedOptions = _.extend(CONFIRM_OPTIONS, options);

            sweetAlert(mergedOptions, isConfirm => {
                if (isConfirm) {
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            });

            return deferred.promise;
        },
    })]);
}))();
